import { Component, Input } from "@angular/core";

import {
  Comment,
  CommentListConfig,
  Discussion,
  PanelMember,
  User,
} from "../../../../models";

import { CommentListResult } from "../../../../interfaces";
import { CommentService } from "../../../../services";

@Component({
  selector: "comment-list",
  templateUrl: "./comment-list.component.html",
  styleUrls: [
    "./comment-list.component.scss",
    "../../../../../../assets/icon/icofont/css/icofont.scss",
  ],
})
export class CommentListComponent {
  constructor(private commentService: CommentService) {}

  public query: CommentListConfig;
  public results: Comment[];
  public loading: boolean = false;
  public currentPage: number = 1;
  public totalPages: number = 1;

  @Input() discussion: Discussion;
  @Input() currentUser: User;
  @Input() currentPanelMember: PanelMember;
  @Input()
  set config(config: CommentListConfig) {
    if (config) {
      this.query = config;
      this.currentPage = 1;
      this.runQuery();
    }
  }

  public fetchAllComments() {
    this.commentService
      .findMany(this.discussion, this.query)
      .subscribe((data: CommentListResult) => {
        this.loading = false;
        this.results = data.comments;
        this.totalPages = data.pages.total;
      });
  }

  public setPageTo(pageNumber: number) {
    this.currentPage = pageNumber;
    this.runQuery();
  }

  public runQuery() {
    this.loading = true;
    this.results = [];
    this.query.offset = this.query.limit * (this.currentPage - 1);
    this.fetchAllComments();
  }

  public changeSortBy(filter: string) {
    this.query.sortBy = filter;
    this.runQuery();
  }

  public changeCommentCount(number: number) {
    this.query.limit = number;
    this.runQuery();
  }
}
